// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"tvcmlaunch_cashback_202404-module--ctaWrapper--NGIHs"};